<template>
  <div class="partner-link__wrapper">
    <button-control
      :is-block="true"
      class="_yellow"
      size="small"
      @click="openModal"
    >
      <icon
        class="partner-link__icon"
        name="Link_24"
        :width="24"
        :height="24"
      />
      Партнерская ссылка
    </button-control>
    <portal to="PartnerLinkModal">
      <partner-link-modal />
    </portal>
  </div>
</template>

<script>
import { ButtonControl } from '@book24/ui-components';
import Icon from '@/js/vue/Icon';
import PartnerLinkModal from '@/js/vue/PartnerLink/PartnerLinkModal';

export default {
  name: 'PartnerLink',
  components: {
    PartnerLinkModal,
    ButtonControl,
    Icon,
  },
  methods: {
    openModal() {
      this.$modal.show('partner-modal');
    },
  },
};
</script>
